'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _pick = require('lodash/pick');var _pick2 = _interopRequireDefault(_pick);
var _reactRedux = require('react-redux');
var _reduxPagan = require('redux-pagan');
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _reduxForm = require('redux-form');
var _reactRouter = require('react-router');

var _formatFullAddress = require('../../utils/formatFullAddress');var _formatFullAddress2 = _interopRequireDefault(_formatFullAddress);
var _assetsToDelete = require('../../redux/modules/assetsToDelete');



var _formatPhoneNumber = require('../../utils/formatPhoneNumber');


var _PropertyDetails = require('./PropertyDetails');var _PropertyDetails2 = _interopRequireDefault(_PropertyDetails);
var _reportIssues = require('../../redux/modules/reportIssues');
var _placesGeocode = require('../../redux/modules/placesGeocode');
var _services = require('../../services');

var _constants = require('../../constants');
var _constants2 = require('./constants');
var _contactUs = require('../../redux/modules/contactUs');
var _messageModal = require('../../redux/modules/messageModal');
var _helpers = require('./helpers');



var _appendLocale = require('../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);
var _AddPropertiesToProjectForm = require('../AddPropertiesToProjectForm/AddPropertiesToProjectForm');var _AddPropertiesToProjectForm2 = _interopRequireDefault(_AddPropertiesToProjectForm);
var _ProjectDetails = require('./ProjectDetails');var _ProjectDetails2 = _interopRequireDefault(_ProjectDetails);
var _containers = require('../../containers');

var _PublishNewHomesForm = require('./PublishNewHomesForm.scss');var styles = _interopRequireWildcard(_PublishNewHomesForm);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}

var changeValue = function changeValue(name, value) {return (0, _reduxForm.change)('addNewProject', name, value);};
var selector = (0, _reduxForm.formValueSelector)('addNewProject');
var replaceAt = function replaceAt(name, position, value) {return (0, _reduxForm.arraySplice)('addNewProject', name, position, 1, value);};var

PublishNewHomesFormComponent = function (_Component) {_inherits(PublishNewHomesFormComponent, _Component);function PublishNewHomesFormComponent() {var _temp, _this, _ret;_classCallCheck(this, PublishNewHomesFormComponent);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    state = {
      isAddProperty: false,
      inputData: _this.props.isEditProject || false,
      isHouseNumber: true,
      phoneNumber: '',
      countryCode: '' }, _this.


































































































    submitForm = function (_ref)


























    {var architect = _ref.architect,owner = _ref.owner,contractor = _ref.contractor,name_project = _ref.name_project,status = _ref.status,property_types = _ref.property_types,minimal_price = _ref.minimal_price,summary = _ref.summary,description = _ref.description,completion_date_months = _ref.completion_date_months,completion_date_years = _ref.completion_date_years,room_range = _ref.room_range,commodities = _ref.commodities,project_img = _ref.project_img,ownerImg = _ref.ownerImg,contractorImg = _ref.contractorImg,architectImg = _ref.architectImg,projectImages = _ref.projectImages,address = _ref.address,exact_price = _ref.exact_price,currency = _ref.currency,advantages = _ref.advantages,apartments = _ref.apartments,floors = _ref.floors,buildings = _ref.buildings,phone_number = _ref.phone_number;var
      isForeign = _this.props.isForeign;
      var images = [];
      var completion_date = (0, _helpers.formatCompletionDate)(completion_date_months, completion_date_years);

      if (projectImages) {
        projectImages.map(function (_ref2) {var link = _ref2.link,angle = _ref2.angle;return images.push({ link: link, angle: angle });});
      }
      if (commodities) {
        commodities = commodities.filter(function (item) {return !!item && item.type && item.items && item.items.length;});
      }

      if (advantages) {
        advantages = advantages.filter(function (item) {return !!item && item.title && item.description;});
      }

      var data = Object.assign({
        name: name_project,
        status: status,
        room_range: room_range,
        property_types: property_types },
      address.place_id ?
      { place_id: address.place_id } :
      { full_address: (0, _formatFullAddress2.default)(address) }, {

        summary: summary,
        description: description,
        logo: (0, _pick2.default)(project_img, _constants2.PROJECT_LOGO_PICK),
        images: images,
        commodities: commodities,
        advantages: advantages,
        apartments: apartments,
        floors: floors,
        buildings: buildings,
        is_foreign: _this.props.isForeign,
        currency: isForeign ? currency || 'USD' : 'ILS',
        min_property_price: (0, _helpers.parsePrice)(minimal_price),
        exact_property_price: (0, _helpers.parsePrice)(exact_price),
        completion_date: completion_date,
        phone_number: (0, _formatPhoneNumber.authenticationFormatPhoneNumber)(phone_number),
        team: {
          owner: {
            title: owner,
            logo: ownerImg && (0, _pick2.default)(ownerImg, _constants2.PROJECT_LOGO_PICK) },

          contractor: {
            title: contractor,
            logo: contractorImg && (0, _pick2.default)(contractorImg, _constants2.PROJECT_LOGO_PICK) },

          architect: {
            title: architect,
            logo: architectImg && (0, _pick2.default)(architectImg, _constants2.PROJECT_LOGO_PICK) } } });




      [].concat(images, [project_img, ownerImg, contractorImg, architectImg]).forEach(function (item) {
        if (item && item.link) {
          _this.props.addAssetToUnsuspend({
            type: 'image',
            id: item.link });

        }
      });

      if (_this.props.isEditProject) {
        var projectId = _this.props.location.query.id;
        return _this.props.editMyProject({ data: data, token: _this.props.userToken, id: projectId });
      }
      return _this.props.addNewProject({ data: data, token: _this.props.userToken });
    }, _this.

    handleSubmit = function (evt) {
      _this.props.handleSubmit(_this.submitForm)(evt);
      return true;
    }, _this.

    handlePhoneChange = function (_evt) {var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';var flag = arguments[2];
      var normalizedValue = value.replace(/\s/g, '');

      if (_this.state.countryCode === '') {
        return _this.setState(function (state) {return Object.assign({},
          state, {
            countryCode: '+' + flag.dialCode });});

      }

      _this.setState({ phoneNumber: normalizedValue });

      if ('+' + flag.dialCode !== _this.state.countryCode) {
        _this.setState({ countryCode: '+' + flag.dialCode });
      }

      return _this.props.changeValue('phone_number', '+' + flag.dialCode + normalizedValue);
    }, _this.

    handleMassageOk = function () {
      if (_this.props.isLoadedFromDraft) {
        var storageField = _this.props.isForeign ? 'publishForeignData' : 'publishData';

        _constants.storage.value.removeItem(storageField);
      }

      if (!_this.state.isAddProperty) {
        _this.setState({ isAddProperty: true });
        _this.props.changeAddProperty();

        _this.props.hideMessageModal();
        _this.props.changeDealType();
      } else {
        _reactRouter.browserHistory.push((0, _appendLocale2.default)(_this.props.locale, '/profile/my_projects'));
      }
    }, _this.

    addAssetToDelete = function (_ref3) {var publicId = _ref3.publicId,contentType = _ref3.contentType;
      _this.props.addAssetToDelete({ id: publicId, type: contentType });
    }, _this.

    renderNewHomesForm = function () {var _this$props =


















      _this.props,translate = _this$props.translate,locale = _this$props.locale,isMobile = _this$props.isMobile,isRtl = _this$props.isRtl,userToken = _this$props.userToken,fields = _this$props.fields,initialValues = _this$props.initialValues,projectImag = _this$props.projectImag,array = _this$props.array,creationNewHomes = _this$props.creationNewHomes,isEditProject = _this$props.isEditProject,anyTouched = _this$props.anyTouched,isAgent = _this$props.isAgent,geocodedPlace = _this$props.geocodedPlace,geocodeFailed = _this$props.geocodeFailed,isForeign = _this$props.isForeign,loading = _this$props.loading;

      var isShowAnotherLanguages = !!(0, _get2.default)(fields, 'nameProject.' + (isForeign ? 'en' : 'he')) &&
      !!(0, _get2.default)(fields, 'summary.' + (isForeign ? 'en' : 'he')) &&
      !!(0, _get2.default)(fields, 'description.' + (isForeign ? 'en' : 'he'));

      return (
        _react2.default.createElement('form', null,
          _react2.default.createElement(_PropertyDetails2.default, {
            fields: fields,
            isForeign: isForeign,
            translate: translate,
            locale: locale,
            isMobile: isMobile,
            token: userToken,
            addAssetToDelete: _this.addAssetToDelete,
            isRtl: isRtl,
            initialValues: initialValues,
            creationNewHomes: creationNewHomes,
            isEditProject: isEditProject,
            changeValue: _this.props.changeValue,
            state: _this.state,
            projectImag: projectImag,
            anyTouched: anyTouched,
            receiveGeocodedPlace: _this.props.receiveGeocodedPlace,
            reportIssue: _this.props.openReportIssueModal,
            isAgent: isAgent,
            geocodedPlace: geocodedPlace,
            geocodeFailed: geocodeFailed,
            openMessageModal: _this.props.openMessageModal,
            incrementClicks: _services.AnalyticsEventService.createPropertyEvent }),

          _this.state.inputData && isShowAnotherLanguages &&
          _react2.default.createElement(_ProjectDetails2.default, {
            openMessageModal: _this.props.openMessageModal,
            translate: translate,
            fields: fields,
            isForeign: isForeign,
            push: array.push,
            remove: array.remove,
            locale: locale,
            isMobile: isMobile,
            token: userToken,
            addAssetToDelete: _this.addAssetToDelete,
            isRtl: isRtl,
            changeValue: _this.props.changeValue,
            initialValues: initialValues,
            replaceAt: _this.props.replaceAt,
            onPhoneChange: _this.handlePhoneChange,
            phoneNumber: _this.state.phoneNumber,
            loading: loading }),


          _react2.default.createElement('div', { className: styles.submitWrapper },
            _react2.default.createElement('button', {
                onClick: _this.handleSubmit,
                disabled: !_this.state.inputData || !isShowAnotherLanguages },

              creationNewHomes.loading ?
              _react2.default.createElement('i', { className: (0, _classnames2.default)('icon icon-om-spinner om-pulse', styles.spinner) }) :
              _react2.default.createElement('span', { className: 'button-text' }, _this.props.translate('addNewProject', 'submit'))))));





    }, _this.

    renderAuthenticationBlock = function () {return (
        _react2.default.createElement(_containers.PublishAuthenticationContainer, {
          isAgent: _this.props.isRealtor }));}, _this.



    renderContent = function () {var _this$props2 =






      _this.props,creationNewHomes = _this$props2.creationNewHomes,isEditProject = _this$props2.isEditProject,location = _this$props2.location,userToken = _this$props2.userToken,isForeign = _this$props2.isForeign;

      if (!userToken) {
        return _this.renderAuthenticationBlock();
      }

      if (_this.state.isAddProperty) {
        return (
          _react2.default.createElement(_AddPropertiesToProjectForm2.default, {
            location: location,
            isEditProject: isEditProject,
            creationNewHomes: creationNewHomes,
            isForeign: isForeign }));


      }

      return _this.renderNewHomesForm();
    }, _temp), _possibleConstructorReturn(_this, _ret);}PublishNewHomesFormComponent.prototype.componentWillMount = function componentWillMount() {var storageField = this.props.isForeign ? 'publishForeignData' : 'publishData';this.props.loadPropertyTypes();if (this.props.isLoadedFromDraft) {this.props.initialize(JSON.parse(_constants.storage.value.getItem(storageField)));}};PublishNewHomesFormComponent.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref4) {var isMessageModalOpen = _ref4.isMessageModalOpen,creationNewHomes = _ref4.creationNewHomes,fields = _ref4.fields,initialValues = _ref4.initialValues,isForeign = _ref4.isForeign;if (fields.address !== this.props.fields.address) {var isFullAddress = (0, _get2.default)(fields, 'address.en.city_name', false) && (0, _get2.default)(fields, 'address.en.street_name', false) && (0, _get2.default)(fields, 'address.en.house_number', false);var isFullForeignAddress = isForeign && (0, _get2.default)(fields, 'address.en.country_name', false) && (0, _get2.default)(fields, 'address.en.city_name', false);var isGooglePlaceIdInitialValues = (0, _get2.default)(initialValues, 'address.google_place_id', null);var isGooglePlaceIdFields = (0, _get2.default)(fields, 'address.google_place_id', null);var isFull = (0, _get2.default)(fields, 'address.isFull', false);if (isFullAddress && (isGooglePlaceIdInitialValues === isGooglePlaceIdFields || isFull) || isFullForeignAddress) {this.setState({ inputData: true });} else {this.setState({ inputData: false, phoneNumber: '', countryCode: '' });}}var phoneNumber = (0, _get2.default)(fields, 'phone_number');if (!this.state.phoneNumber && phoneNumber) {this.setState({ phoneNumber: phoneNumber });}var stateModifier = {};if (creationNewHomes.loading !== this.props.creationNewHomes.loading) {stateModifier.sending = creationNewHomes.loading;}if (creationNewHomes.loaded && creationNewHomes.loaded !== this.props.creationNewHomes.loaded) {var formProjectSent = this.props.isEditProject ? 'editProjectForm' : 'formProjectSent';var formPropertySent = this.props.isEditProject ? 'editPropertyForm' : 'formPropertySent';this.props.changeAssetsTags();this.props.openMessageModal({ message: _react2.default.createElement('div', { className: 'contentMessage' }, _react2.default.createElement('div', null, _react2.default.createElement('p', null, this.props.translate('addNewProject', !this.state.isAddProperty ? formProjectSent : formPropertySent)), _react2.default.createElement('button', { className: 'btn btn-primary', onClick: this.handleMassageOk }, this.props.translate('contactUsPage', 'ok')))), isCloseButtonInvisible: true });}if (creationNewHomes.error && creationNewHomes.error !== this.props.creationNewHomes.error) {this.props.openMessageModal({ message: _react2.default.createElement('div', { className: 'contentMessage' }, _react2.default.createElement('div', null, _react2.default.createElement('p', null, this.props.translate('myProjects', 'errorMessage')), _react2.default.createElement('button', { className: 'btn btn-primary', onClick: this.props.hideMessageModal }, this.props.translate('contactUsPage', 'ok')))) });}if (!isMessageModalOpen && creationNewHomes.loaded && this.props.isMessageModalOpen) {this.props.reset();}};PublishNewHomesFormComponent.prototype.

  render = function render() {
    return (
      _react2.default.createElement('div', { className: styles.container },
        this.renderContent()));


  };return PublishNewHomesFormComponent;}(_react.Component);


PublishNewHomesFormComponent.propTypes = {
  translate: _propTypes2.default.func,
  locale: _propTypes2.default.string.isRequired,
  isMobile: _propTypes2.default.bool,
  sendContactUsForm: _propTypes2.default.func,
  openMessageModal: _propTypes2.default.func,
  hideMessageModal: _propTypes2.default.func,
  isMessageModalOpen: _propTypes2.default.bool,
  isRtl: _propTypes2.default.bool,
  handleSubmit: _propTypes2.default.func,
  userToken: _propTypes2.default.string,
  addNewProject: _propTypes2.default.func,
  error: _propTypes2.default.object,
  fields: _propTypes2.default.object,
  projectImag: _propTypes2.default.array,
  handleRequest: _propTypes2.default.func,
  reset: _propTypes2.default.func,
  addAssetToDelete: _propTypes2.default.func,
  addAssetToUnsuspend: _propTypes2.default.func,
  changeAssetsTags: _propTypes2.default.func,
  array: _propTypes2.default.object,
  loadPropertyTypes: _propTypes2.default.func,
  creationNewHomes: _propTypes2.default.object,
  changeValue: _propTypes2.default.func,
  editMyProject: _propTypes2.default.func,
  location: _propTypes2.default.object,
  initialValues: _propTypes2.default.object,
  isEditProject: _propTypes2.default.bool,
  openReportIssueModal: _propTypes2.default.func,
  receiveGeocodedPlace: _propTypes2.default.func,
  anyTouched: _propTypes2.default.bool,
  isAgent: _propTypes2.default.bool,
  geocodedPlace: _propTypes2.default.object,
  geocodeFailed: _propTypes2.default.bool,
  changeDealType: _propTypes2.default.func,
  changeAddProperty: _propTypes2.default.func,
  initialize: _propTypes2.default.func,
  isRealtor: _propTypes2.default.bool,
  isLoadedFromDraft: _propTypes2.default.bool,
  isForeign: _propTypes2.default.bool,
  replaceAt: _propTypes2.default.func,
  loading: _propTypes2.default.bool };


var mapStateToProps = function mapStateToProps(state) {return {
    userToken: (0, _get2.default)(state, 'userAuthentication.data.access_token'),
    translate: (0, _reduxPagan.getLang)(state.lang, 'static'),
    locale: state.lang.locale,
    isMobile: state.windowDimentions.isMobile,
    userData: state.userAuthentication.data,
    contactUs: state.contactUs,
    isAgent: state.userAuthentication.data ? (0, _get2.default)(state.userAuthentication, 'data.is_agent') : selector(state, 'customerType') === 'agent',
    geocodeFailed: !!state.placesGeocode.error || state.placesGeocode.geocodedPlace === null,
    geocodedPlace: state.placesGeocode.geocodedPlace,
    loading: (0, _get2.default)(state, 'manageProperties.loading', false) };};


var mapDispatchToProps = {
  addAssetToDelete: _assetsToDelete.addAssetToDelete,
  addAssetToUnsuspend: _assetsToDelete.addAssetToUnsuspend,
  changeAssetsTags: _assetsToDelete.changeAssetsTags,
  sendContactUsForm: _contactUs.sendContactUsForm,
  openMessageModal: _messageModal.openMessageModal,
  hideMessageModal: _messageModal.hideMessageModal,
  openReportIssueModal: _reportIssues.openReportIssueModal,
  receiveGeocodedPlace: _placesGeocode.receiveGeocodedPlace,
  changeValue: changeValue,
  replaceAt: replaceAt };exports.default =


(0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PublishNewHomesFormComponent);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/PublishNewHomesForm/PublishNewHomesFormComponent.js
// module id = 3060
// module chunks = 0